// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Hn2q","content":"styles_content__3FH5b","checkbox":"styles_checkbox__2xojT","checkboxLabel":"styles_checkboxLabel__nhi6M"};